import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  canvas: {
    flex: 1,
    background: palette['grey-950'],
    border: `1px solid ${palette['lighted-10']}`,
    borderRadius: anatomy.borderRadiusM,
    padding: anatomy['size-20'],
    position: 'relative',
    height: '528px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  canvasHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: anatomy['size-8'],
  },
  emptyState: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    width: '488px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: anatomy['size-28'],
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: anatomy['size-8'],
  },
  emptyStateTitle: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    fontWeight: typography.fontWeighRegular,
    color: palette['greyWhite'],
    textAlign: 'center',
    margin: 0,
  },
  emptyStateDescription: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-300'],
    textAlign: 'center',
    margin: 0,
  },
  cursorIcon: {
    width: '160px',
    height: '160px',
  },
});
